module.exports = __webpack_public_path__ + "static/media/icon_register.9d89cc6a.svg";